"use strict";

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

exports.onRouteUpdate = function (_ref, _ref2) {
    var trackPage = _ref2.trackPage;

    _objectDestructuringEmpty(_ref);

    if (trackPage) {
        window.analytics && window.analytics.page();
    }
};